var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Duplicate = function Duplicate(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 12 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'duplication'
      ),
      React.createElement('path', { d: 'M9.922 11h-5C3.817 11 3 10.112 3 9.007v-7C3 .903 3.817 0 4.922 0h3L12 4.008v4.999c0 1.1-.978 1.993-2.078 1.993zM10 5H7V2H5v7h5V5zm-1 9H2.922C1.267 14 0 12.662 0 11.008V4h2v7.008c0 .551.371.992.922.992H9v2z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Duplicate;
//# sourceMappingURL=Duplicate.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Duplicate.js